// Belt-and-suspenders alongside the CSS `pointer-events: none` rule on
// `.pdp-immersive-gallery .product__modal-opener`: intercept in the CAPTURE
// phase at the document level (fires before Dawn's own listeners, which are
// wherever they are in the tree) so tapping the full-screen photo never opens
// Dawn's built-in zoom modal. Real devices showed the CSS-only rule wasn't
// enough to stop it, so this stops the click before it can reach Dawn's
// handler at all. Only 'click' is intercepted (not touchstart/touchmove), so
// native horizontal swipe-scrolling between photos is untouched.
document.addEventListener(
  'click',
  function (e) {
    var opener = e.target.closest && e.target.closest('.pdp-immersive-gallery .product__modal-opener');
    if (opener) {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) {
        e.stopImmediatePropagation();
      }
    }
  },
  true
);

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-pdp-immersive-back]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (window.history.length > 1) {
        window.history.back();
      } else {
        window.location.href = '/';
      }
    });
  });

  document.querySelectorAll('[data-pdp-immersive-share]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var title = btn.getAttribute('data-share-title') || document.title;
      var url = btn.getAttribute('data-share-url') || window.location.href;

      if (navigator.share) {
        navigator.share({ title: title, url: url }).catch(function () {});
        return;
      }

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(function () {
          btn.setAttribute('data-copied', 'true');
          setTimeout(function () {
            btn.removeAttribute('data-copied');
          }, 1500);
        });
      }
    });
  });

  // As the customer swipes through the full-screen gallery, show a small
  // floating label with the color name of whichever photo is currently in
  // view (when that photo belongs to a specific color variant). This is
  // DELIBERATELY read-only: it only ever reads which slide is visible and
  // writes text into the badge. It never checks a swatch radio button and
  // never fires a variant 'change' event. That's intentional — Dawn's own
  // variant-change handling (assets/product-info.js) does a network fetch
  // and then re-sorts the gallery's <li> elements (prepending the newly
  // selected variant's photo to the front of the list) and force-scrolls
  // the gallery to it. Wiring that up to fire on every swipe would fight
  // the customer's own swipe, reorder photos out from under their thumb,
  // and spam network requests. So swiping only ever updates this label;
  // actually switching color is still a deliberate tap on the real swatch.
  document.querySelectorAll('.pdp-immersive-gallery').forEach(function (gallery) {
    var mapScript = gallery.querySelector('[data-pdp-immersive-color-map]');
    var badge = gallery.querySelector('[data-pdp-immersive-color-badge]');
    var list = gallery.querySelector('.product__media-list');
    if (!mapScript || !badge || !list) return;

    var colorByMediaId = {};
    try {
      JSON.parse(mapScript.textContent).forEach(function (entry) {
        colorByMediaId[String(entry.mediaId)] = entry.color;
      });
    } catch (err) {
      return;
    }

    var slides = Array.from(list.querySelectorAll('[data-pdp-media-numeric-id]'));
    if (!slides.length) return;

    var currentColor = null;

    function showColor(color) {
      if (color === currentColor) return;
      currentColor = color;
      if (color) {
        badge.textContent = color;
        badge.hidden = false;
      } else {
        badge.hidden = true;
      }
    }

    var observer = new IntersectionObserver(
      function (entries) {
        var best = null;
        entries.forEach(function (entry) {
          if (!best || entry.intersectionRatio > best.intersectionRatio) {
            best = entry;
          }
        });
        if (best && best.intersectionRatio > 0.6) {
          var mediaId = best.target.getAttribute('data-pdp-media-numeric-id');
          showColor(colorByMediaId[mediaId] || null);
        }
      },
      { root: list, threshold: [0, 0.6, 1] }
    );

    slides.forEach(function (slide) {
      observer.observe(slide);
    });
  });
});
